
const API_URL = process.env.REACT_APP_API_URL

export const getSearchResultsByQuery = async (query, rank) => {
    return await fetch(`${API_URL}/api/search?query=${query}&rank=${rank}`);
}
